/**
 * Selección de plataforma en tiempo de build (__PLATFORM__ lo define vite.config.ts).
 * Cada build incluye solo el código de su plataforma.
 */
import type { Platform } from "./types";
import { webPlatform } from "./web";

declare const __PLATFORM__: "web" | "desktop" | "android";

let impl: Platform = webPlatform;

export async function initPlatform(): Promise<Platform> {
  if (__PLATFORM__ === "desktop") impl = (await import("./desktop")).desktopPlatform;
  else if (__PLATFORM__ === "android") impl = (await import("./android")).androidPlatform;
  else {
    const { registerServiceWorker } = await import("./web");
    // 1.177.0: la tienda en el dominio propio de un negocio no instala la app (ni guarda copias para usar sin internet).
    if (!document.querySelector('meta[name="sofia-store"]')) await registerServiceWorker();
  }
  Object.assign(platform, impl);
  return impl;
}

/** Objeto estable: se completa en initPlatform() antes de montar la app. */
export const platform: Platform = { ...webPlatform };

export type { Platform, PrinterConfig, PrinterConnection } from "./types";
